import React, { useState, useEffect } from 'react';
import './CustomSwitchButton.scss';
function CustomSwitchButton(props) {
  const onChange = props.onChange;
  const defaultChecked = props.defaultChecked;
  const disabled = props.disabled;
  const [checked, setChecked] = useState(defaultChecked);

  useEffect(() => {
    setChecked(defaultChecked);
  }, [defaultChecked]);
  return (
    <label className="custom-switch-button">
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={() => {
          onChange(!checked);
          setChecked(!checked);
        }}
      />
      <span className="custom-switch-button-slider"></span>
    </label>
  );
}

export default CustomSwitchButton;
